module.exports = __webpack_public_path__ + "static/media/file-ppt.b13afd50.svg";